import { FaRegUserCircle } from 'react-icons/fa';
import { useLanguage } from '../../../../../Hooks/Contexts/Translate/useLanguageContext';
import { useNavigate } from 'react-router-dom';
import { useHeaderUtilities } from '../_Hooks/useHeaderUtilities';
import { UtilityDropdown, UtilityItem, UtilityAction } from '../UtilityDropdown';

export const Profile = ({ user, links = [], onClickLogout }) => {

    const navigate = useNavigate();

    const { useDataLanguage } = useLanguage();

    const TEXT = useDataLanguage.translations?.TEMPLATES?.header ?? {};

    const { onClose } = useHeaderUtilities();

    const onGoTo = (path) => { onClose(); navigate(path); };

    const onLogout = () => { onClose(); if (onClickLogout) onClickLogout(); };

    return (
        <UtilityDropdown id="profile" label={user?.name ?? TEXT.account} width={260}
            icon={<FaRegUserCircle size={18} />} >

            <UtilityItem title={user?.name ?? TEXT.guest} description={user?.email} />

            {
                links.map((link) => (
                    <UtilityItem key={link.path} title={link.label}
                        onClick={() => onGoTo(link.path)} />
                ))
            }

            <UtilityAction onClick={onLogout} isDanger>{TEXT.logout}</UtilityAction>

        </UtilityDropdown>
    );
};